// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Style moderne sans variables CSS root */
/* Fond principal avec effet glassmorphism */
ion-content {
  --background: linear-gradient(135deg, #9ba5ff 0%, #4846b8 50%, #0c2061 100%);
  position: relative;
  overflow: hidden;
  min-height: 100vh;
}

/* Effet de particules animées en arrière-plan */
ion-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 60% 60%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 30% 70%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 10% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%), radial-gradient(circle at 90% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%);
  animation: float 15s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  25% {
    transform: translateY(-10px) translateX(5px);
  }
  50% {
    transform: translateY(0) translateX(10px);
  }
  75% {
    transform: translateY(10px) translateX(5px);
  }
}
/* Container principal avec glassmorphism */
ion-grid {
  position: relative;
  z-index: 1;
  max-width: 400px;
  margin: 0 auto;
  padding: 2rem;
  margin-top: 8rem;
}

/* Carte glassmorphism pour le formulaire */
form {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

form::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left 0.5s;
}

form:hover::before {
  left: 100%;
}

form:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(31, 38, 135, 0.5);
}

/* Styling des champs de saisie */
ion-item {
  --background: rgba(255, 255, 255, 0.9);
  --border-radius: 12px;
  --inner-padding-start: 16px;
  --inner-padding-end: 16px;
  --padding-start: 0;
  --padding-end: 0;
  margin-bottom: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
}

ion-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

ion-item.item-has-focus {
  --background: rgba(255, 255, 255, 0.95);
  border-color: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-clip: padding-box;
}

/* Labels flottants améliorés */
ion-label {
  --color: #636e72;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

ion-item.item-has-focus ion-label {
  --color: #667eea;
  font-weight: 600;
}

/* Champs de saisie */
ion-input {
  --color: #2d3436;
  --placeholder-color: #636e72;
  font-size: 1rem;
  font-weight: 500;
}

/* Bouton de connexion moderne */
.btn {
  width: 100%;
  height: 3.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: none;
  margin: 1.5rem auto 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
}

.btn:hover::before {
  left: 100%;
}

.btn:active {
  transform: translateY(0);
}

/* Zone des liens */
.links-container {
  text-align: center;
  margin-top: 1.5rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.links-container a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0.5rem;
  border-radius: 6px;
  display: inline-block;
}

.links-container a:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

/* Bouton de mise à jour */
.update-container {
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}

.update-container ion-button {
  --background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  --color: white;
  --border-radius: 25px;
  --padding-start: 2rem;
  --padding-end: 2rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.update-container ion-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(245, 87, 108, 0.6);
}

/* Animation de vibration pour les erreurs */
@keyframes shake {
  0%, 20%, 40%, 60%, 80%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-5px);
  }
}
.shake {
  animation: shake 0.5s ease-in-out;
}

/* Responsive design */
@media (max-width: 768px) {
  ion-grid {
    padding: 1rem;
    margin-top: 4rem;
  }
  form {
    padding: 1.5rem;
  }
  .btn {
    height: 3rem;
    font-size: 1rem;
  }
}
/* Animation d'entrée */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
form {
  animation: fadeInUp 0.6s ease-out;
}

/* Indicateur de chargement */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  z-index: 10;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/login/login.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,0CAAA;AAEA,4CAAA;AACA;EACI,4EAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEE,gDAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gqBACE;EAQF,yCAAA;EACA,UAAA;EACA,oBAAA;AAPJ;;AAUE;EACE;IACE,sCAAA;EAPJ;EASE;IACE,4CAAA;EAPJ;EASE;IACE,yCAAA;EAPJ;EASE;IACE,2CAAA;EAPJ;AACF;AAUE,2CAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AARJ;;AAWE,2CAAA;AACA;EACE,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,8CAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AARJ;;AAWE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,qBAAA;AARJ;;AAWE;EACE,UAAA;AARJ;;AAWE;EACE,2BAAA;EACA,8CAAA;AARJ;;AAWE,iCAAA;AACA;EACE,sCAAA;EACA,qBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,iDAAA;EACA,6BAAA;AARJ;;AAWE;EACE,2BAAA;EACA,0CAAA;AARJ;;AAWE;EACE,uCAAA;EACA,+DAAA;EACA,6DAAA;EACA,4BAAA;AARJ;;AAWE,+BAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;AARJ;;AAWE;EACE,gBAAA;EACA,gBAAA;AARJ;;AAWE,qBAAA;AACA;EACE,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AARJ;;AAWE,gCAAA;AACA;EACE,WAAA;EACA,cAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iDAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;AARJ;;AAWE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,qBAAA;AARJ;;AAWE;EACE,2BAAA;EACA,+CAAA;AARJ;;AAWE;EACE,UAAA;AARJ;;AAWE;EACE,wBAAA;AARJ;;AAWE,mBAAA;AACA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,0CAAA;AARJ;;AAWE;EACE,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AARJ;;AAWE;EACE,oCAAA;EACA,2BAAA;AARJ;;AAWE,0BAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;AARJ;;AAWE;EACE,+DAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8CAAA;EACA,iDAAA;AARJ;;AAWE;EACE,2BAAA;EACA,8CAAA;AARJ;;AAWE,4CAAA;AACA;EACE;IAA+B,wBAAA;EAPjC;EAQE;IAA0B,2BAAA;EAL5B;AACF;AAOE;EACE,iCAAA;AALJ;;AAQE,sBAAA;AACA;EACE;IACE,aAAA;IACA,gBAAA;EALJ;EAQE;IACE,eAAA;EANJ;EASE;IACE,YAAA;IACA,eAAA;EAPJ;AACF;AAUE,uBAAA;AACA;EACE;IACE,UAAA;IACA,2BAAA;EARJ;EAUE;IACE,UAAA;IACA,wBAAA;EARJ;AACF;AAWE;EACE,iCAAA;AATJ;;AAYE,6BAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AATJ;;AAYE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AATJ;;AAYE;EACE;IAAK,uBAAA;EARP;EASE;IAAO,yBAAA;EANT;AACF","sourcesContent":["/* Style moderne sans variables CSS root */\r\n\r\n/* Fond principal avec effet glassmorphism */\r\nion-content {\r\n    --background: linear-gradient(135deg, #9ba5ff 0%, #4846b8 50%, #0c2061 100%);\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-height: 100vh;\r\n  }\r\n  \r\n  /* Effet de particules animées en arrière-plan */\r\n  ion-content::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-image: \r\n      radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 60% 60%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 30% 70%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 10% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%),\r\n      radial-gradient(circle at 90% 50%, rgba(255, 255, 255, 0.2) 0%, transparent 15%);\r\n    animation: float 15s ease-in-out infinite;\r\n    z-index: 1;\r\n    pointer-events: none;\r\n  }\r\n  \r\n  @keyframes float {\r\n    0%, 100% { \r\n      transform: translateY(0) translateX(0);\r\n    }\r\n    25% { \r\n      transform: translateY(-10px) translateX(5px);\r\n    }\r\n    50% { \r\n      transform: translateY(0) translateX(10px);\r\n    }\r\n    75% { \r\n      transform: translateY(10px) translateX(5px);\r\n    }\r\n  }\r\n  \r\n  /* Container principal avec glassmorphism */\r\n  ion-grid {\r\n    position: relative;\r\n    z-index: 1;\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n    padding: 2rem;\r\n    margin-top: 8rem;\r\n  }\r\n  \r\n  /* Carte glassmorphism pour le formulaire */\r\n  form {\r\n    background: rgba(255, 255, 255, 0.1);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border: 1px solid rgba(255, 255, 255, 0.2);\r\n    border-radius: 16px;\r\n    padding: 2rem;\r\n    box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  form::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);\r\n    transition: left 0.5s;\r\n  }\r\n  \r\n  form:hover::before {\r\n    left: 100%;\r\n  }\r\n  \r\n  form:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 12px 40px rgba(31, 38, 135, 0.5);\r\n  }\r\n  \r\n  /* Styling des champs de saisie */\r\n  ion-item {\r\n    --background: rgba(255, 255, 255, 0.9);\r\n    --border-radius: 12px;\r\n    --inner-padding-start: 16px;\r\n    --inner-padding-end: 16px;\r\n    --padding-start: 0;\r\n    --padding-end: 0;\r\n    margin-bottom: 1.5rem;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    border: 2px solid transparent;\r\n  }\r\n  \r\n  ion-item:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\r\n  }\r\n  \r\n  ion-item.item-has-focus {\r\n    --background: rgba(255, 255, 255, 0.95);\r\n    border-color: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    background-clip: padding-box;\r\n  }\r\n  \r\n  /* Labels flottants améliorés */\r\n  ion-label {\r\n    --color: #636e72;\r\n    font-weight: 500;\r\n    font-size: 0.9rem;\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  }\r\n  \r\n  ion-item.item-has-focus ion-label {\r\n    --color: #667eea;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  /* Champs de saisie */\r\n  ion-input {\r\n    --color: #2d3436;\r\n    --placeholder-color: #636e72;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  /* Bouton de connexion moderne */\r\n  .btn {\r\n    width: 100%;\r\n    height: 3.5rem;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 12px;\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    letter-spacing: 0.5px;\r\n    text-transform: none;\r\n    margin: 1.5rem auto 2rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .btn::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\r\n    transition: left 0.5s;\r\n  }\r\n  \r\n  .btn:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);\r\n  }\r\n  \r\n  .btn:hover::before {\r\n    left: 100%;\r\n  }\r\n  \r\n  .btn:active {\r\n    transform: translateY(0);\r\n  }\r\n  \r\n  /* Zone des liens */\r\n  .links-container {\r\n    text-align: center;\r\n    margin-top: 1.5rem;\r\n    padding: 1rem;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    backdrop-filter: blur(10px);\r\n    border-radius: 12px;\r\n    border: 1px solid rgba(255, 255, 255, 0.2);\r\n  }\r\n  \r\n  .links-container a {\r\n    color: white;\r\n    text-decoration: none;\r\n    font-weight: 500;\r\n    font-size: 0.95rem;\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    padding: 0.5rem;\r\n    border-radius: 6px;\r\n    display: inline-block;\r\n  }\r\n  \r\n  .links-container a:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    transform: translateY(-1px);\r\n  }\r\n  \r\n  /* Bouton de mise à jour */\r\n  .update-container {\r\n    position: fixed;\r\n    bottom: 2rem;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .update-container ion-button {\r\n    --background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\r\n    --color: white;\r\n    --border-radius: 25px;\r\n    --padding-start: 2rem;\r\n    --padding-end: 2rem;\r\n    font-weight: 600;\r\n    letter-spacing: 0.5px;\r\n    box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  }\r\n  \r\n  .update-container ion-button:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 25px rgba(245, 87, 108, 0.6);\r\n  }\r\n  \r\n  /* Animation de vibration pour les erreurs */\r\n  @keyframes shake {\r\n    0%, 20%, 40%, 60%, 80%, 100% { transform: translateX(0); }\r\n    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }\r\n  }\r\n  \r\n  .shake {\r\n    animation: shake 0.5s ease-in-out;\r\n  }\r\n  \r\n  /* Responsive design */\r\n  @media (max-width: 768px) {\r\n    ion-grid {\r\n      padding: 1rem;\r\n      margin-top: 4rem;\r\n    }\r\n    \r\n    form {\r\n      padding: 1.5rem;\r\n    }\r\n    \r\n    .btn {\r\n      height: 3rem;\r\n      font-size: 1rem;\r\n    }\r\n  }\r\n  \r\n  /* Animation d'entrée */\r\n  @keyframes fadeInUp {\r\n    from {\r\n      opacity: 0;\r\n      transform: translateY(30px);\r\n    }\r\n    to {\r\n      opacity: 1;\r\n      transform: translateY(0);\r\n    }\r\n  }\r\n  \r\n  form {\r\n    animation: fadeInUp 0.6s ease-out;\r\n  }\r\n  \r\n  /* Indicateur de chargement */\r\n  .loading-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(255, 255, 255, 0.9);\r\n    backdrop-filter: blur(5px);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 16px;\r\n    z-index: 10;\r\n  }\r\n  \r\n  .loading-spinner {\r\n    width: 40px;\r\n    height: 40px;\r\n    border: 3px solid #f3f3f3;\r\n    border-top: 3px solid #667eea;\r\n    border-radius: 50%;\r\n    animation: spin 1s linear infinite;\r\n  }\r\n  \r\n  @keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
